import React, { useState } from 'react';
import { useAuth } from './AuthProvider';
import Auth from './Auth';
import './LoginModal.css';

function LoginModal({ isOpen, onClose, onLoginSuccess }) {
  const { login, register } = useAuth();
  const [showWelcome, setShowWelcome] = useState(false);

  const handleLogin = (user, token) => {
    login(user, token);
    onLoginSuccess && onLoginSuccess();
    onClose();
  };

  const handleWelcomeComplete = (user, token) => {
    register(user, token);
    onLoginSuccess && onLoginSuccess();
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="login-modal-overlay">
      <div className="login-modal-backdrop" onClick={onClose}></div>
      <div className="login-modal-content">
        <div className="login-modal-header">
          <img src="/duckbuilder.png" alt="Duckbuilder" className="login-modal-logo" />
          {!showWelcome && <p>Create an account or sign in to save your decks!</p>}
          <button className="login-modal-close" onClick={onClose}>
            ×
          </button>
        </div>
        
        <div className="login-modal-body">
          <Auth 
            onLogin={handleLogin}
            onRegister={handleWelcomeComplete}
            isModal={true}
            onWelcomeStateChange={setShowWelcome}
          />
        </div>
      </div>
    </div>
  );
}

export default LoginModal; 